import Head from 'next/head';
import Link from 'next/link';

import { PageWrapperStyles } from '../common/PageWrapper';
import { H1 } from '../common/headline';
import { BodyLarge } from '../common/body';
import { Section } from '../common/Section';

export default function Custom404(): JSX.Element {
  return (
    <PageWrapperStyles>
      <Head>
        <title>Page Not Found | Second Nature</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <Section backgroundColour="bg-dawn-blue-100">
        <div className="container mx-auto px-4 py-16 text-center text-blue">
          <H1>404 - Page Not Found</H1>
          <div className="my-8">
            <BodyLarge>
              The page you are looking for doesn&apos;t exist or has been moved.
            </BodyLarge>
          </div>
          <div className="mx-auto mt-12 max-w-xs text-blue-800 underline">
            <Link href="/">Return to Homepage</Link>
          </div>
        </div>
      </Section>
    </PageWrapperStyles>
  );
}
